"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequirementsList = exports.SectionHeaderSmall = exports.SectionHeaderLarge = void 0;
var merch_components_1 = require("@carvana/merch-components");
exports.SectionHeaderLarge = (0, merch_components_1.createComponent)('h2', {
    className: 'text-[20px] leading-6 text-blue-6'
});
exports.SectionHeaderSmall = (0, merch_components_1.createComponent)('h3', {
    className: 't-header-xs flex items-center gap-4 text-blue-6'
});
exports.RequirementsList = (0, merch_components_1.createComponent)('ul', {
    className: 'mb-0 flex list-none flex-col gap-4 px-0 text-sm text-grey-5'
});
//# sourceMappingURL=EVTaxCreditContent.styles.js.map